import React from 'react';
import styled from 'styled-components';

const StyledSection = styled.section`
  fontfamily: 'Poppins, sans-serif';
  .overlay:before {
    background: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;
  }
`;

const Contact = ({ landingPrimaryColor, appPhoneNumber }) => {
  return (
    appPhoneNumber && (
      <StyledSection landingPrimaryColor={landingPrimaryColor}>
        <section
          id="contact-link"
          class="call-action overlay"
          data-stellar-background-ratio="0.5"
          landingPrimaryColor={landingPrimaryColor}
        >
          <div class="container">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-12">
                <div class="content">
                  <h2>Do you have any questions?</h2>
                  <h2>Please feel free to reach us @</h2>
                  <h2>+91 {appPhoneNumber}</h2>
                </div>
              </div>
            </div>
          </div>
        </section>
      </StyledSection>
    )
  );
};

export default Contact;
